// Cart drawer / cart page add-ons (replaces the Essential app, 2026-10-26).
// - Upgrade button (snippets/glo7-cart-boost.liquid): swaps a "Buy 1" line for the "Buy 2 …" variant.
// - <g7-cart-recs>: loads sections/glo7-cart-recs.liquid via Shopify product recommendations; Add buttons.
// Adds are tagged so orders show where they came from: line property _g7_source / cart attribute g7_upgrade.
// Loaded from both the drawer and the cart page, so it guards against running twice.
(() => {
  if (window.g7CartBoost) return;
  window.g7CartBoost = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  async function cartRequest(btn, path, body) {
    const drawer = btn.closest('cart-drawer');
    if (drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }
    btn.disabled = true;
    try {
      const res = await fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || res.status);
      if (drawer && data.sections) drawer.renderContents({ id: null, sections: data.sections });
      else window.location.reload();
    } catch (err) {
      btn.disabled = false;
      btn.textContent = 'Try again';
      console.error('g7-cart-boost', err);
    }
  }

  document.addEventListener('click', (e) => {
    const up = e.target.closest('[data-g7-upgrade]');
    const add = e.target.closest('[data-g7-add]');
    if (up) {
      e.preventDefault();
      cartRequest(up, 'cart/update.js', {
        updates: { [up.dataset.lineKey]: 0, [up.dataset.g7Upgrade]: 1 },
        attributes: { g7_upgrade: 'yes' },
      });
    } else if (add) {
      e.preventDefault();
      cartRequest(add, 'cart/add.js', {
        items: [{ id: Number(add.dataset.g7Add), quantity: 1, properties: { _g7_source: 'cart-rec' } }],
      });
    }
  });

  // Recommendations: complementary (set in Search & Discovery) first, then Shopify's automatic "related".
  // Cached per cart contents so drawer re-renders don't refetch or flicker.
  const cache = new Map();
  class G7CartRecs extends HTMLElement {
    async connectedCallback() {
      const id = this.dataset.productId;
      const key = this.dataset.cartKey;
      if (!id) return;
      if (cache.has(key)) {
        this.innerHTML = cache.get(key);
        return;
      }
      for (const intent of ['complementary', 'related']) {
        try {
          const res = await fetch(`${root}recommendations/products?section_id=glo7-cart-recs&product_id=${id}&limit=6&intent=${intent}`);
          if (!res.ok) continue;
          const el = new DOMParser().parseFromString(await res.text(), 'text/html').querySelector('.g7-recs');
          if (el && el.querySelector('.g7-rec')) {
            cache.set(key, el.outerHTML);
            this.innerHTML = el.outerHTML;
            return;
          }
        } catch (err) {
          console.error('g7-cart-recs', err);
        }
      }
      cache.set(key, '');
    }
  }
  if (!customElements.get('g7-cart-recs')) customElements.define('g7-cart-recs', G7CartRecs);
})();
